import React from 'react';
import TsMemberImg from './TsMemberImg.jsx';
import { Tooltip } from 'react-tippy';

class TsSprintDetailItemCol extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		};
	}

	render () {
		// Par défaut le contenu n'est pas en bold
		let boldClass = "";

		// Si on a précisé le vouloir en bold
		if (this.props.bold) {
			boldClass = "proxima-bold";
		}

		// On instancie le texte de la tooltip
		let tooltipTexte = "";

		// Si on affiche la tooltip
		if (this.props.showTooltip) {
			// On récupère le template de la tooltip
			tooltipTexte = this.props.tooltipTemplate;

			// On parcourt l'objet des valeurs à remplacer
			for (const value in this.props.tooltipTemplateValues) {
				// On récupère la valeur courante
				const currentValue = this.props.tooltipTemplateValues[value];

				// On remplace la valeur
				tooltipTexte = tooltipTexte.replace(`{${value}}`, currentValue);
			}
		}

		return (
			<div className={"col txtmiddle txt-center " + boldClass}>
				{/* Si on ne veut pas afficher d'image, ou si la source de l'image est null 
					et que l'on souhaite afficher la tooltip */}
				{(! this.props.img || this.props.imgSrc === null) && this.props.showTooltip &&
					<Tooltip
						title={tooltipTexte}
						animation={"shift"}
						animateFill={false}
						arrow={false}
						arrowSize={"small"}
						theme={"light"}
						size={"big"}
					>
						<p>{this.props.content}</p>
					</Tooltip>
				}

				{/* Si on ne veut pas afficher d'image, ou si la source de l'image est null 
					et que l'on ne souhaite pas afficher la tooltip */}
				{(! this.props.img || this.props.imgSrc === null) && ! this.props.showTooltip &&
					<p>{this.props.content}</p>
				}

				{/* Si on veut afficher une image et que la source n'est pas null */}
				{this.props.img && this.props.imgSrc !== null &&
					<TsMemberImg imgSrc={this.props.imgSrc} />
				}
			</div>
		);
	}
}

export default TsSprintDetailItemCol;


// WEBPACK FOOTER //
// ./src/js/TsSprintDetailItemCol.jsx